import * as React from 'react';
import Room from '../Room';
import SpotSeventhFloor from './SpotSeventhFloor';
import type { IRoomProps } from './TableShape';

// Floor plan per Odoo room.office id. Offices without an entry show only the desk list.
const OFFICE_LAYOUTS: Partial<Record<number, React.FC<IRoomProps>>> = {
  1: SpotSeventhFloor, // The Spot - 7th Floor
  2: Room, // The Spot - 6th Floor
};

export default OFFICE_LAYOUTS;
